import { Pipe, PipeTransform } from "@angular/core";
import { CurrencyService } from "app/services/currency/currency.service";

@Pipe({
  name: 'convertExchange',
  pure: false
})
export class ConvertExchangePipe implements PipeTransform {

  constructor(
    private currencyService: CurrencyService
  ) {}

  transform(amountTHB: number): string {
    const transformedValue = this.currencyService.transformCurrentCurrencyFromTHB(amountTHB);
    return transformedValue.toLocaleString();
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/convert-exchange.pipe.ts